<h2 mat-dialog-title>
  {{
    'Dashboard.Settings.Title'
      | translate: locale.language : { title: data.definition.title | translate: locale.language }
  }}
</h2>

<mat-dialog-content>
  @if (mode === 'component') {
    @let state = settingsComponent.state();
    @if (state.status === 'loading') {
      <output class="settings-loading">
        <mat-spinner diameter="32" [attr.aria-label]="'Dashboard.Settings.Loading' | translate: locale.language" />
      </output>
    } @else if (state.status === 'ready') {
      <div #customSettingsHost>
        <ng-container *ngComponentOutlet="state.component; injector: settingsInjector" />
      </div>
    } @else {
      <p class="settings-message settings-error" role="alert">
        {{ 'Dashboard.Settings.LoadFailed' | translate: locale.language }}
      </p>
      <button mat-button type="button" (click)="settingsComponent.retry()">
        {{ 'Dashboard.Frame.TryAgain' | translate: locale.language }}
      </button>
    }
  } @else if (data.definition.settingsSchema; as schema) {
    <jsonforms
      class="settings-form"
      [schema]="schema"
      [data]="initialSettings"
      [renderers]="renderers"
      (dataChange)="onDataChange($event)"
      (errors)="onErrors($event)" />
  }

  @if (brokenComponent() || saveFailed()) {
    <p class="settings-message settings-error" role="alert">
      {{ 'Dashboard.Settings.CantSave' | translate: locale.language }}
    </p>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">
    {{ 'Dashboard.Settings.Cancel' | translate: locale.language }}
  </button>
  <button mat-flat-button color="primary" type="button" [disabled]="!canSave()" (click)="save()">
    {{ 'Dashboard.Settings.Save' | translate: locale.language }}
  </button>
</mat-dialog-actions>
